export const styles = {
  container: "hyam-layout-full-width h-fit",
};

export type S01ImageSlidesDesktopMobileDefaultStyles =
  typeof styles;
